export default {
  toasts: {
    printing: 'Stampa in corso...',
    print_failed: 'Stampa non riuscita. Riprova',
    orders: {
      print_one: 'Stampa {{count}} ricevuta: Ordine <strong>#{{orderNumber}}</strong>...',
      print_other: 'Stampa {{count}} ricevute: Ordine <strong>#{{orderNumber}}</strong>...',
    },
  },
};
